export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#', thStyle: { width: '80px' } },
    { key: 'region', label: 'Region', sortable: true },
    { key: 'name', label: 'name', sortable: true },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
  }
}
